module.exports = __webpack_public_path__ + "media/Your Home.27e0d6c2.mp3";